import { useState } from 'react'
import { useTranslation } from 'libs'

import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import Header from 'components/Header'
import PageWrapper from 'components/Ui/PageWrapper'
import Form from 'components/Ui/Form'
import Input from 'components/Ui/Input'
import { useForm } from 'react-hook-form'
import { useAxiosPrivate } from 'hooks'
import { useToast } from 'hooks'
import ColorPicker from 'components/ColorPicker'
// import { addBoothTypeValidationSchema } from 'schemas/validation'
import { Dimensions } from './styles'

const BoothTypeAddPage = () => {
	const { t } = useTranslation()
	const defaultColor = '#FFFFFF'
	const [primaryColor, setPrimaryColor] = useState(defaultColor)
	const [secondaryColor, setSecondaryColor] = useState(defaultColor)

	const handlePrimaryColorChange = (data: any) => {
		const { hex } = data

		setPrimaryColor(hex)
	}
	const handleSecondaryColorChange = (data: any) => {
		const { hex } = data

		setSecondaryColor(hex)
	}

	const addBoothTypeValidationSchema = yup.object({
		name: yup.string().required(t('validation.addBoothType.name.required')),
		dimensions: yup.object({
			height: yup.string().required(t('validation.addBoothType.dimensions.height.required')),
			width: yup.string().required(t('validation.addBoothType.dimensions.width.required')),
			depth: yup.string().required(t('validation.addBoothType.dimensions.depth.required'))
		})
	})
	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({
		mode: 'onChange',
		resolver: yupResolver(addBoothTypeValidationSchema)
	})
	const axiosPrivate = useAxiosPrivate()
	const navigate = useNavigate()
	const successMessage = useToast({ type: 'success', message: t('addBoothType.form.success') })
	const failMessage = useToast({ type: 'error', message: t('addBoothType.form.error') })
	const queryClient = useQueryClient()

	const { mutate: createBoothType, isLoading: isCreateBoothTypeLoading } = useMutation(
		(data) => {
			return axiosPrivate.post('/booth-types/', data)
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('fetchBoothTypes')
				successMessage()

				navigate('/booth-types')
			},
			onError: () => {
				failMessage()
			}
		}
	)

	const onSubmit = (data: any) => {
		data.primary_color = primaryColor
		data.secondary_color = secondaryColor
		createBoothType(data)
	}

	return (
		<>
			<Header title={t('addBoothType.title')} />
			<PageWrapper>
				<Form
					submitText={t('addBoothType.form.submitText')}
					onSubmit={handleSubmit(onSubmit)}
					isLoading={isCreateBoothTypeLoading}>
					<Input
						id="name"
						label={t('addBoothType.form.name')}
						{...register('name')}
						error={(errors as any).name}
						required={true}
					/>
					<Input
						id="description"
						label={t('addBoothType.form.description')}
						{...register('description')}
					/>
					<Dimensions>
						<Input
							id="height"
							label={t('addBoothType.form.height')}
							type="number"
							{...register('dimensions.height')}
							error={(errors as any).dimensions?.height}
							required={true}
						/>
						<Input
							id="width"
							label={t('addBoothType.form.width')}
							type="number"
							{...register('dimensions.width')}
							error={(errors as any).dimensions?.width}
							required={true}
						/>
						<Input
							id="depth"
							label={t('addBoothType.form.depth')}
							type="number"
							{...register('dimensions.depth')}
							error={(errors as any).dimensions?.depth}
							required={true}
						/>
					</Dimensions>
					<ColorPicker
						label={t('addBoothType.form.primaryColor')}
						color={primaryColor}
						onChange={handlePrimaryColorChange}
					/>
					<ColorPicker
						label={t('addBoothType.form.secondaryColor')}
						color={secondaryColor}
						onChange={handleSecondaryColorChange}
					/>
				</Form>
			</PageWrapper>
		</>
	)
}

export default BoothTypeAddPage
